import { useState, useEffect, useContext } from "react";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Button, TextField } from "@material-ui/core";
import { UserContext } from "../../context/UserContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function ProfileForm({
  defaultUser,
  curUser,
  setCurUser,
  closeForm,
  setCloseForm,
}) {
  const { user } = useContext(UserContext);

  const navigate = useNavigate();

  const updateProfile = (e) => {
    e.preventDefault();
    axios
      .put("api/user/", curUser, {
        headers: {
          "x-auth-token": user,
        },
      })
      .then((res) => {
        console.log(res);
        setCloseForm(!closeForm);
        // navigate("/home");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  let key_name, val;
  const handleInputs = (e) => {
    key_name = e.target.name;
    val = e.target.value;
    setCurUser({ ...user, [key_name]: val });
  };

  const handleImage = () => {
    alert("Image Handled");
  };

  return (
    <>
      <form encType="multipart/form-data">
        <div className="user_items">
          <TextField
            label="Full Name"
            name="fullName"
            // defaultValue={curUser?.fullName}
            value={curUser?.fullName}
            onChange={handleInputs}
            InputLabelProps={{ className: "textfield__label" }}
          />
        </div>

        <div className="user_items">
          <TextField
            label="Email"
            name="email"
            // defaultValue={curUser?.email}
            value={curUser?.email}
            onChange={handleInputs}
            InputLabelProps={{ className: "textfield__label" }}
            TextField={{ className: "textfield__border" }}
          />
        </div>

        <div className="user_items">
          <TextField
            label="Bio"
            name="bio"
            // defaultValue={curUser?.bio}
            value={curUser.bio ? curUser.bio : ""}
            multiline
            rows={4}
            onChange={handleInputs}
            InputLabelProps={{ className: "textfield__label" }}
            TextField={{ className: "textfield__border" }}
          />
        </div>

        {/* {curUser?.skills?.length > 0 && (
          <div className="user_items user_items2">
            <h3 className="textfield__label">Skills</h3>
            <TextField
              // label="Enter Skill"
              name="skills"
              // defaultValue={curUser?.skills[0]}
              value={curUser?.skills[0].value}
              onChange={handleInputs}
              InputLabelProps={{ className: "textfield__label" }}
              TextField={{ className: "textfield__border" }}
            />
          </div>
        )} */}

        <div className="user_items user_items3">
          <h3 className="textfield__label">Social Links</h3>
          <TextField
            label="Github"
            name="github"
            // defaultValue={curUser?.github}
            value={curUser?.github}
            onChange={handleInputs}
            InputLabelProps={{ className: "textfield__label" }}
            TextField={{ className: "textfield__border" }}
          />

          <TextField
            label="LinkedIn"
            name="linkedIn"
            // defaultValue={curUser?.linkedIn}
            value={curUser?.linkedIn}
            onChange={handleInputs}
            InputLabelProps={{ className: "textfield__label" }}
            TextField={{ className: "textfield__border" }}
          />

          <TextField
            label="Instagram"
            name="instagram"
            // defaultValue={curUser?.instagram}
            value={curUser?.instagram}
            onChange={handleInputs}
            InputLabelProps={{ className: "textfield__label" }}
            TextField={{ className: "textfield__border" }}
          />
        </div>

        {/* <div className="user_items">
          <FormControl style={{ width: "100%", marginTop: 15 }}>
            <InputLabel style={{ color: "rgb(187, 187, 187)" }}>
              Category
            </InputLabel>
            <Select
              autoWidth={true}
              style={{ color: "rgb(187, 187, 187)" }}
              value={curUser?.category}
              label="Category"
              name="category"
              // InputLabelProps={{ className: 'textfield__label' }}
              onChange={handleInputs}
            >
              <MenuItem style={{ backgroundColor: "none" }}>
                <em>~Select Category~</em>
              </MenuItem>
              {categories.map((cat) => (
                <MenuItem key={cat.id} value={cat.name}>
                  {cat.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div> */}

        {/* UPLOAD IMAGES */}
        <div className="user_items user_items2">
          <h3 className="textfield__label">Upload Image</h3>
          <label className="upload" htmlFor="upload_resume">
            <p>+</p>
          </label>
          <input
            type="file"
            id="upload_resume"
            name="img"
            accept="image/*"
            onChange={handleImage}
            hidden
          />
        </div>
        {/* closes UPLOAD IMAGES */}

        <div className="user_items user_btns">
          <Button
            className="update_btn"
            variant="contained"
            onClick={(e) => {
              updateProfile(e);
            }}
          >
            {curUser?._id === "" ? "ADD" : "UPDATE"}
          </Button>

          <Button className="del_btn" variant="contained" onClick={() => setCloseForm(!closeForm)}>
            CLOSE
          </Button>
        </div>
      </form>
    </>
  );
}
